import ImportPlatformsComponent from 'pages/import/importPlatforms';
import { StoreContext } from 'models/import';
import { useContext, useEffect, useState } from 'react';

function IntegrationsComponent() {
  const { setIsIntegrationsPage, setImportTableSettings } = useContext(StoreContext);
  const [contextAvailable, setContextAvailable] = useState(false);

  useEffect(() => {
    // reset importTableSettings if navigated away from overview detail to integrations
    setImportTableSettings(undefined);

    setIsIntegrationsPage(true);
    setContextAvailable(true);

    return () => {
      setIsIntegrationsPage(undefined);
    };
  }, []);

  return contextAvailable ? <ImportPlatformsComponent /> : null;
}

export default IntegrationsComponent;
